module.exports = __webpack_public_path__ + "img/gamesdk12.4052389.png";